import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  progressBar: {
    width: '100%',
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
  },
  content: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(3, 2),
    gap: theme.spacing(0.5),
    borderRadius: theme.spacing(1),
    border: `1px solid ${theme.palette.divider}`,
    lineHeight: 1,
    marginBottom: theme.spacing(2),
  },
  title: {
    fontSize: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
  },
  fileSize: {
    fontSize: theme.spacing(1.5),
    color: theme.palette.text.secondary,
    marginLeft: theme.spacing(1),
  },
  fileName: {
    fontSize: theme.spacing(1.875),
  },
  tagsInputs: {
    display: 'flex',
    width: '100%',
    gap: theme.spacing(1),
  },
  tagInputField: {
    display: 'flex',
    flex: 1,
    width: '100%',
    maxWidth: '100%',
  },
}));
